<script>
import resourceSelect from '../../mixins/resourceSelect';

export default {
  mixins: [resourceSelect],

  data() {
    return {
      route: 'api.roles.index',
      defaults: {
        trackBy: 'id',
        label: 'label',
        searchable: false,
        placeholder: 'Sélectionnez un rôle',
      },
    };
  },
};
</script>